export default function AttachPreparationItemFolderDirective() {
  return {
    template: require('./attach-preparation-item-folder.html'),
    scope: {
      customerId: '=',
      preparationItemId: '=',
      serviceId: '=',
      parentFolderId: '=',
      folderId: '=',
      folder: '=',
    },
    controller: 'AttachPreparationItemFolderController',
    controllerAs: 'attachPreparationItemFolderVM',
    bindToController: true,
    replace: true
  };
}
